import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import Confirm from 'components/Sales/Smart/ConfirmOrderShipment';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartConfirm(): JSX.Element {
  return (
    <ContentLayout titleKey="titles.confirmOrderShipment" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}>
      <Confirm />
    </ContentLayout>
  );
}
